import { StateType } from '../index';

export const leaderboardSelector = (state: StateType) => state.getIn(['leaderboard']);
